module.exports = {
    qualifiers: [
        'code',
        'optional',
        'default',
        'auto',
        'readOnly',
        'writeOnce',
        'forceUpdate',
        'freezeAfterNonDefault',
        'comment',
        'displayName',
        'generator',
        'constraintOnUpdate',
        'constraintOnDelete',
        'hasActivator',
    ],
};
